import $ from 'jquery'; 
import _ from "lodash";

import React from "react";
import Loading from "../../etc/Loading";
import Button from "components/CustomButtons/Button.jsx";
import {graphql, compose, withApollo} from "react-apollo";
import SweetAlert from "react-bootstrap-sweetalert";
import { getProjectsQuery } from "../graph";
import Table from '../../elements/Table';
import Notification from '../../elements/Notifications';
import {projectsStyle} from '../style';
import withStyles from "material-ui/styles/withStyles";

import ViewButton from '../../elements/Buttons';
import gql from 'graphql-tag';
import Utils from "lib/utils";
import GenerateUsersModal from "../../users/components/GenerateUsersModal";
import PinAssignmentModal from "../../pin/components/PinAssignModal";
import CreateProjectModal from "./Create";

import AddToPhotos from "@material-ui/icons/AddToPhotos";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Call from "@material-ui/icons/Call";
import DashboardIcon from "@material-ui/icons/Dashboard";
import List from "@material-ui/icons/List";
import NoteAdd from "@material-ui/icons/NoteAdd";
import Pageview from "@material-ui/icons/Pageview";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Tooltip from 'material-ui/Tooltip';

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import Divider from '@material-ui/core/Divider';
import IconCard from "components/Cards/IconCard";
import ReactTable from "react-table";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


export const log = (type) => console.log.bind(console, type);

const LIST_BOX_QUERY = gql`
  subscription {
    testusers {
      uid
    }
  }
`;

class Projects extends React.Component {

  constructor(props){
    super(props);
    
    this.state = { 
      usersModalIsOpen: false,
      assignPinsModalIsOpen: false,
      createProjectModalIsOpen:false,
      assignPinSuccessIsOpen: false,
      notification:false,
      notificationMessage:"",
      color:"success",
      position:"br", 
      projects: [],
      loading: true, 
      pages: 0,
      assignTotalPin: 0,
      assignTotalUser: 0
    };

    this.projectId = null;
    this.projectName = null;
    this.page = 0;
    this.loadedAll = false;

    this.headers = [
            {Header:"Project ID",accessor:"projid", minWidth: 50},
            {Header:"Server PID",accessor:"pid", minWidth: 50},
            {Header:"Name",accessor:"name", Cell: row => <div><span title={row.value}>{row.value}</span></div>},
            {Header:"Phone Number",accessor:"extension"},
            {Header:"Active",accessor:"active"},
            {
              Header:"Actions",
              accessor:"actions",
              minWidth: 200,
              sortable:false,
              filterable:false
            }
    ];

    this.projectRefresh = this.projectRefresh.bind(this);
    this.notificationClose = this.notificationClose.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  onCreateUsersCallback(event) {
    this.projectId = event.currentTarget.getAttribute("serverid");
    this.setState({
        usersModalIsOpen: true
    });
  }
  onUsersModalClose() {
    this.setState({
        usersModalIsOpen: false
    });
  }
  
  closeAssignPinModal(totalPin, totalUser, type) {
    if (type == "close") {
      this.setState({
        assignPinsModalIsOpen: false,
      });
    }
    else {
      this.setState({
          assignPinsModalIsOpen: false,
          assignPinSuccessIsOpen: true,
          assignTotalUser: totalUser,
          assignTotalPin: totalPin,
      });
    }
  }
  assignPinsByUser(event) {
    this.projectId = event.currentTarget.getAttribute("serverid");
    this.projectName = this.state.projects.filter(obj => { return obj.pid === this.projectId })[0].name
    this.setState({
        assignPinsModalIsOpen: true
    });
  }
  
  closeCreateProjectsModal() {
    this.setState({
        createProjectModalIsOpen: false
    });
  }

  closeAssignSuccessModal() {
    this.setState({
        assignPinSuccessIsOpen: false
    });
  }

  openCreateProjectsModal() {
    this.setState({
        createProjectModalIsOpen: true
    });
  }
  projectRefresh(message){
    let that = this;
    this.setState({ loading: true })
    setTimeout(function(){ 
        that.props.client.query({
          query: getProjectsQuery,
            variables: {
              offset: 0, 
              filterBy: JSON.stringify([]),
              pageSize: 10,
              sort: JSON.stringify([])
            },
        }).then((data) => {
          that.setState({
            projects: data.data.projects.projects, 
            loading: false,   
            pages: data.data.projects.pages
          });
          that.showNotification(message,"success","br");    
        }).catch(() => {
          console.log('error')
        });
      }, 1000);


  }
  notificationClose(){
    this.setState({"notification":"false"});
  }
  showNotification(message,color,position){
    this.setState({
      "notification":true,
      "notificationMessage":message,
      "position":position,
      "color":color
    });
    setTimeout(
      function() {
        this.setState({"notification":false,"notificationMessage":""});
      }.bind(this),
      6000
    );
  }

  fetchData(state=null, instance=null, options={}){
    this.setState({ loading: true })
    if (state){
        var filterBy = JSON.stringify(state.filtered)
        var offset = state.page
        var pageSize = state.pageSize
        var sort = JSON.stringify(state.sorted)
    } else {
        var filterBy = JSON.stringify([])
        var offset = 0
        var pageSize = 10
        var sort = JSON.stringify([])
    }
   options = {fetchPolicy: 'no-cache'}
    this.props.client.query({
      query: getProjectsQuery,
      variables: {
        filterBy: filterBy,
        offset: offset, 
        pageSize: pageSize,
        sort: sort
      }, 
      options: options
    }).then((data) => {
      this.setState({
        projects: data.data.projects.projects, 
        loading: false, 
        pages: data.data.projects.pages
      });
    });
  }

  render() {
    const { searchString, usersModalIsOpen, 
      assignPinsModalIsOpen, createProjectModalIsOpen,
      notification, assignPinSuccessIsOpen, 
      assignTotalUser, assignTotalPin } = this.state;
    let usersModal, assignPinModal, createProjectModal,notificationBar, assignPinSuccessModal;
    const {classes} = this.props;

    if (assignPinSuccessIsOpen) {
      assignPinSuccessModal = (
        <SweetAlert
        title="Pins successfully assigned"
        onConfirm={() => this.closeAssignSuccessModal()}
        onCancel={() => this.closeAssignSuccessModal()}
        showCancel={false}
        showConfirm={true}
        confirmBtnTxt="Ok"
      >
      You have assigned a total of {assignTotalPin} pins to {assignTotalUser} users
      </SweetAlert>
      );
    }
    
    if (notification){
      notificationBar = (
        <Notification
          message = {this.state.notificationMessage}
          close = {this.notificationClose}
          open = {this.state.notification}
          notifyCallback = {this.showNotification}
          position = {this.state.position}
          color = "danger" //{this.state.color}
        />
      )
    }
    if (usersModalIsOpen) {
          usersModal = (<GenerateUsersModal 
            projectId={this.projectId}
            usersModalIsOpen={usersModalIsOpen} 
            onUsersModalClose={this.onUsersModalClose.bind(this)}/>);
    }
    
    if(assignPinsModalIsOpen){
      assignPinModal = (<PinAssignmentModal
          projectId={this.projectId}
          projectName={this.projectName}
          assignPinModalIsOpen = {assignPinsModalIsOpen}
          assignPinModalClose = {this.closeAssignPinModal.bind(this)}
        />);
    }
    if(createProjectModalIsOpen){
      createProjectModal = (<CreateProjectModal
        createProjectsModalIsOpen = {createProjectModalIsOpen}
        createProjectsModalClose = {this.closeCreateProjectsModal.bind(this)}
        projectRefresh = {this.projectRefresh}
        showNotification = {this.showNotification}
        lastPage = { (this.state.pages-1 < 1) ? 0 : 1 }
      />);
    }

    let table_data = {
      id: "projectsTable",
      rows : this.state.projects,
      header : this.headers,
      actions: ['view','generate', 'interface', 'logs', 'createUsers', 'assignPins'],
      buttons: {
        'view': {
          'key':"pid",
          'url':"projects/:id",
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="View Project"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Pageview/>
                  </Tooltip>,
            'color':'primaryNoBackground',
            'class':'like',
          },
          'text':''
        },
        'generate':{
          'key':'pid',
          'url':'projects/generate_pins/:id',
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="Generate Pins"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><AddToPhotos/></Tooltip>,
            'color':'successNoBackground',
            'class':'',
          },
          'text':''
        },
        'interface': {
          'key':"pid",
          'url':"projects/:id/webInterface",
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="Callform"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><Call/></Tooltip>,
            'color':'roseNoBackground',
            'class':'',
          },
          'text':''
        },
        'createUsers': {
          'key':"pid",
          'callback': this.onCreateUsersCallback.bind(this),
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="Create users"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><PersonAdd/></Tooltip>,
            'color':'warningNoBackground',
            'class':'',
          },
          'text':''
        },
        'logs': {
          'key':"pid",
          'url':"projects/:id/logs",
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="Pin Logs"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><List/></Tooltip>,
            'color':'infoNoBackground',
            'class':'',
          },
          'text':''
        }, 
        'assignPins': {
          'key':"pid",
          'callback': this.assignPinsByUser.bind(this),
          'style':{
            'obj':<Tooltip
                    id="tooltip-top"
                    title="Assign pins to users"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><AssignmentInd/></Tooltip>,
            'color':'dangerNoBackground',
            'class':'',
          },
        },
        hasSearchBar: true,
        searchString: searchString
      }   
    };

    let _this = this;
    return(
      <div>
        {assignPinSuccessModal}
        {usersModal}
        {assignPinModal}
        {createProjectModal}
        {notificationBar}
        <GridContainer>
          <ItemGrid xs={12}>
            <IconCard
              icon={DashboardIcon}
              title="Projects"
              content={
                <GridContainer>
                  {/*<ItemGrid xs={12}>
                    <Button 
                      size="sm" 
                      color="primary"
                      onClick={() => this.openCreateProjectsModal()}
                      >
                      <NoteAdd/>&nbsp;&nbsp;Create Project
                    </Button>
                  </ItemGrid>*/}
                  <ItemGrid xs={12}>
                    <Table title="Projects" 
                      data={table_data}
                      pages={_this.state.pages}
                      loading={_this.state.loading}
                      onFetchData={_this.fetchData}
                      defaultPageSize={10}
                    />
                  </ItemGrid>
                </GridContainer>
              }
            />
          </ItemGrid>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(projectsStyle, sweetAlertStyle)(withApollo(Projects))



// WEBPACK FOOTER //
// ./src/views/projects/components/Projects.js